// ============================================================================
//  ALIA PRODUCTION - generated by 3b-build-frontends-prod.ps1 on 2026-10-22 15:50
//  Lifted VERBATIM from the bundle currently serving production:
//    D:\Certacure\v26.9.7-26.10.19\sites\FrontEnd_-_HIS\main.fb69541b720bfca3.js
//  Angular bakes these URLs into the bundle, so they cannot be changed after the build. The repo
//  default (192.168.1.114) and Alia staging (HTTP, different ports) are both wrong for prod.
//  Known defects in these values are carried forward deliberately and reported in the release
//  plan - they are NOT silently corrected during a cutover.
//  The untouched repo original is beside this file as environment.prod.ts.repo-original
// ============================================================================
export const environment = {
    production: true,
    useAuthService: true,
    admission: "https://his.aliaih.com:8083/api/",
    core: "https://his.aliaih.com:8084/api/",
    lab: "https://his.aliaih.com:8085/api/",
    pharmacy: "https://his.aliaih.com:8087/api/",
    nurse: "https://his.aliaih.com:8098/api/",
    queryModel: "https://his.aliaih.com:8088/api/",
    order: "https://his.aliaih.com:8089/api/",
    authorityService: "https://his.aliaih.com:9090",
    redirectURI: "https://his.aliaih.com/callback",
    silentRedirectURI: "https://his.aliaih.com/silent",
    postLogoutRedirectURI: "https://his.aliaih.com",
    reportViewer: "https://his.aliaih.com:9092/Default.aspx",
    reportViewerWithParams: "https://his.aliaih.com:9092/ReportWithParam.aspx",
    crystalReportViewer: "https://his.aliaih.com:9002/CrystalReport.aspx",
    specimenBarcodeReportViewer: "https://his.aliaih.com:9092/LabSpecimen.aspx",
    notificationURI: "wss://his.aliaih.com:8181/connect?access_token=",
    sendNotificationURI: "https://his.aliaih.com:8181/api/Notification",
    coreImagePath: "https://his.aliaih.com:8084/imageStorage/",
    dynamicFormViewer: "https://his.aliaih.com:9095",
    dynamicFormPath: "https://his.aliaih.com:9099/api/",
    webSocketRetry: 1,
    autoRefreshSeconds: 30,
    nursingManagement: "https://his.aliaih.com:8090",
    eClaimIntegration: true,
    dimensionUrl: "https://his.aliaih.com:9081/api/",
    dimension: "https://tpo-stg.ehc.jo/api/",
    dimensionAttachement: "https://tpo-stg.ehc.jo:8000/api/",
    dimensionLicenseID: "JOR-F-000011",
    dimensionUsername: "Istishari",
    dimensionPassword: "iii.123$",
    dimensionDemographicInfo: "https://PRD-EHSAPI.ehc.jo/Api/v1/index.php",
    appointment: "https://his.aliaih.com:8093/api/",
    appointmentURI: "https://his.aliaih.com:8094/",
    mediSpanIntegration: true,
    mobileIntegrationEnabled: false,
    mediSpanUrl: "https://his.aliaih.com:8086/api/",
    operationManagement: "https://his.aliaih.com:6601",
    cpoeManagement: "https://his.aliaih.com:5515",
    queryBuilder: "https://his.aliaih.com:21361/api",
    sqlBuilderEngine: "https://his.aliaih.com:6602",
    worksheetTemplate: "_WorkSheet",
    notification: "https://his.aliaih.com:8282/",
    enableNotification: true,
    enableOncology: false,
    oncology: "https://his.aliaih.com:6604/api/",
    oncologyManagement: "https://his.aliaih.com:6605",
    outPatientMonitorIntervalCallback: 5,
    enableAppointment: true,
    operation: "https://his.aliaih.com:8081/api/",
    enableOperation: false,
    httpAggregatorApi: "https://his.aliaih.com:6655/api/",
    specimenLISReportURI: "http://something/orderId=",
    allowMultiReturn: false,
    cateringManagement: "https://his.aliaih.com:5555",
    discountSetup: 0,
    labReportViewer: "https://his.aliaih.com:9092/LabSpecimen.aspx",
    validateSaudiNumber: false,
    messenger: 'https://his.aliaih.com:44340',
    messengerUrl: 'https://his.aliaih.com:5545',
    SecuGenUrl: 'https://localhost:8443/SGIFPCapture',
    SecuGenBody: 'Timeout=10000&Quality=20&templateFormat=ISO&licstr=',
    isSurveyMenuVisible: true,
    VatIntegrationManagement: 'https://his.aliaih.com:5502',
    paciWebSocketUrl: 'ws://localhost:8080',
    homeCareUrl: 'https://his.aliaih.com:5504',
    orderAndBillingImagePath: "https://his.aliaih.com:8089/imageStorage/",
    enableOutstandingBalanceAlert: true, // alert when a patient who still owes the hospital is opened/searched
};